module.exports = __webpack_public_path__ + "img/post_box.00531a74.svg";